import { debugManager } from '@tunein/web-utils';
import { v4 as uuidv4 } from 'uuid';
const debug = debugManager.createDebugger('APSIFRAME', '[Web Common] Amazon Publisher Services Bidder (IFRAME)');
const SECURITY_TOKEN = uuidv4();
const getIframeHtml = (isDebugEnabled) => `
<!DOCTYPE html>
<html lang="en">
<head>
  <script async src="https://c.amazon-adsystem.com/aax2/apstag.js"></script>
  <script>
    const appToken = '${SECURITY_TOKEN}';

    window.addEventListener('message', function (event) {
      const { type, payload, token } = event.data;

      if (token !== appToken) {
        return;
      }

      if (type === 'INIT') {
        function onApsInit() {
          if (${isDebugEnabled}) {
            apstag.debug('enable');
          }

          parent.postMessage({ type: 'INIT_COMPLETE', token }, '*');
        }

        apstag.init(payload, onApsInit);
        return;
      }

      if (type === 'FETCH_BIDS') {
        apstag.fetchBids(payload, function (bids) {
          parent.postMessage({ type: 'BIDS', bids, token }, '*');
        });
      }
    });
  </script>
</head>
<body></body>
</html>
`;
export class ApsIframe {
    #iframe;
    #onReady;
    #iframeReady;
    #didFail = false;
    #bidsReady;
    constructor(isDebugEnabled = false) {
        this.#iframeReady = Promise.withResolvers();
        if (!debug.isActive() && isDebugEnabled) {
            debug.toggle({ verbose: true });
        }
    }
    #onIframeMessage = (event) => {
        const { type, bids, token } = event.data;
        if (token !== SECURITY_TOKEN) {
            return;
        }
        if (type === 'INIT_COMPLETE') {
            debug.verbose('APS iframe initialized');
            window.removeEventListener('message', this.#onIframeMessage);
            this.#onReady?.();
            return;
        }
        if (type === 'BIDS' && this.#bidsReady) {
            debug.verbose('Received APS bids from iframe', bids);
            window.removeEventListener('message', this.#onIframeMessage);
            this.#bidsReady.resolve(bids);
        }
    };
    async init(options, onReady) {
        debug.verbose('Initializing APS iframe');
        this.#onReady = onReady;
        const blob = new Blob([getIframeHtml(debug.isActive())], {
            type: 'text/html',
        });
        const iframeUrl = URL.createObjectURL(blob);
        this.#iframe = document.createElement('iframe');
        this.#iframe.src = iframeUrl;
        this.#iframe.id = 'aps-iframe';
        this.#iframe.style.display = 'none';
        this.#iframe.onload = () => this.#iframeReady.resolve();
        this.#iframe.onerror = () => {
            this.#didFail = true;
            this.#iframeReady.resolve();
            onReady();
        };
        document.body.appendChild(this.#iframe);
        await this.#iframeReady.promise;
        if (this.#didFail) {
            return;
        }
        window.addEventListener('message', this.#onIframeMessage);
        this.#iframe.contentWindow?.postMessage({
            type: 'INIT',
            payload: options,
            token: SECURITY_TOKEN,
        });
    }
    async fetchBids(options) {
        if (this.#didFail || !this.#iframeReady) {
            return;
        }
        await Promise.all([this.#iframeReady.promise, this.#bidsReady?.promise]);
        this.#bidsReady = Promise.withResolvers();
        window.addEventListener('message', this.#onIframeMessage);
        this.#iframe.contentWindow?.postMessage({
            type: 'FETCH_BIDS',
            payload: options,
            token: SECURITY_TOKEN,
        });
        return this.#bidsReady.promise;
    }
}
